module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/GUNPOWDER-Layered.15562b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/GUNPOWDER-Layered.jpg
// module id = +pc4
// module chunks = 0